import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import FFNewsSider from './ffNewsSider';
import FFNews from './ffNews';

class FFHAndFiction extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { ffNewsSiderData, ffNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <FFNewsSider content={ffNewsSiderData} />
                <FFNews content={ffNewsData} />
            </div>
        );
    }
}

export default errorBoundary(FFHAndFiction);
